import defaultStates, { saveStates } from '@/constants/lifecycle';

export const readUsergroupActions = {
  CLOSE_USERGROUP: 'CLOSE_USERGROUP',
  CLOSE_USERGROUPS: 'CLOSE_USERGROUPS',
  FETCH_USERGROUP_USERS_SEARCH: 'FETCH_USERGROUP_USERS_SEARCH',
  FETCH_USERGROUP: 'FETCH_USERGROUP',
  FETCH_USERGROUPS_METRICS: 'FETCH_USERGROUPS_METRICS',
  FETCH_USERGROUPS: 'FETCH_USERGROUPS',
  SHOW_CLONED_USERGROUP: 'SHOW_CLONED_USERGROUP',
  SHOW_USERGROUP_ERROR: 'SHOW_USERGROUP_ERROR',
  SHOW_USERGROUP_USERS_SEARCH_ERROR: 'SHOW_USERGROUP_USERS_SEARCH_ERROR',
  SHOW_USERGROUP_USERS_SEARCH: 'SHOW_USERGROUP_USERS_SEARCH',
  SHOW_USERGROUP: 'SHOW_USERGROUP',
  SHOW_USERGROUPS_ERROR: 'SHOW_USERGROUPS_ERROR',
  SHOW_USERGROUPS_METRICS_ERROR: 'SHOW_USERGROUPS_METRICS_ERROR',
  SHOW_USERGROUPS_METRICS: 'SHOW_USERGROUPS_METRICS',
  SHOW_USERGROUPS: 'SHOW_USERGROUPS',
  TOGGLE_USERGROUP_SELECTED: 'TOGGLE_USERGROUP_SELECTED',
  TOGGLE_USERGROUPS_PRESENTATION: 'TOGGLE_USERGROUPS_PRESENTATION',
  TOGGLE_USERGROUPS_SELECTED: 'TOGGLE_USERGROUPS_SELECTED',
  UPDATE_USERGROUP_PANELS: 'UPDATE_USERGROUP_PANELS',
  UPDATE_USERGROUP_USERS_SEARCH_FILTER: 'UPDATE_USERGROUP_USERS_SEARCH_FILTER',
  UPDATE_USERGROUPS_FILTER: 'UPDATE_USERGROUPS_FILTER',
};

export const updateUsergroupActions = {
  EDIT_USERGROUP: 'EDIT_USERGROUP',
  EDIT_USERGROUP_CANCEL: 'EDIT_USERGROUP_CANCEL',
  UPDATE_ACTIVE_USERGROUP_PROPERTIES: 'UPDATE_ACTIVE_USERGROUP_PROPERTIES',
  UPDATE_USERGROUP: 'UPDATE_USERGROUP',
  UPDATE_USERGROUP_ERROR: 'UPDATE_USERGROUP_ERROR',
  UPDATE_USERGROUP_PROPERTIES: 'UPDATE_USERGROUP_PROPERTIES',
  UPDATE_USERGROUP_SUCCESS: 'UPDATE_USERGROUP_SUCCESS',
};

export const deleteUsergroupActions = {
  DELETE_USERGROUP: 'DELETE_USERGROUP',
  DELETE_USERGROUP_ERROR: 'DELETE_USERGROUP_ERROR',
  DELETE_USERGROUP_SUCCESS: 'DELETE_USERGROUP_SUCCESS',
  HIDE_DELETE_USERGROUP_DIALOG: 'HIDE_DELETE_USERGROUP_DIALOG',
  SHOW_DELETE_USERGROUPS_DIALOG: 'SHOW_DELETE_USERGROUPS_DIALOG',
  SHOW_DELETE_USERGROUP_DIALOG: 'SHOW_DELETE_USERGROUP_DIALOG',
};

export const createUsergroupActions = {
  CREATE_USERGROUP: 'CREATE_USERGROUP',
  CREATE_USERGROUP_ERROR: 'CREATE_USERGROUP_ERROR',
  CREATE_USERGROUP_SUCCESS: 'CREATE_USERGROUP_SUCCESS',
  HIDE_SAVE_USERGROUP_DIALOG: 'HIDE_SAVE_USERGROUP_DIALOG',
  NEW_USERGROUP_FROM_SOURCE: 'NEW_USERGROUP_FROM_SOURCE',
  SHOW_SAVE_USERGROUP_DIALOG: 'SHOW_SAVE_USERGROUP_DIALOG',
};

export const usergroupUsersActions = {
  ADD_USERGROUP_USERS: 'ADD_USERGROUP_USERS',
  ADD_USERGROUP_USERS_ERROR: 'ADD_USERGROUP_USERS_ERROR',
  ADD_USERGROUP_USERS_SUCCESS: 'ADD_USERGROUP_USERS_SUCCESS',
  ADD_USERGROUP_USERS_LOCAL: 'ADD_USERGROUP_USERS_LOCAL',
  DISMISS_USERGROUP_USERS_ERROR: 'DISMISS_USERGROUP_USERS_ERROR',
  FETCH_USERGROUP_USERS: 'FETCH_USERGROUP_USERS',
  REMOVE_USERGROUP_USER: 'REMOVE_USERGROUP_USER',
  REMOVE_USERGROUP_USER_ERROR: 'REMOVE_USERGROUP_USER_ERROR',
  REMOVE_USERGROUP_USER_SUCCESS: 'REMOVE_USERGROUP_USER_SUCCESS',
  REMOVE_USERGROUP_USER_LOCAL: 'REMOVE_USERGROUP_USER_LOCAL',
  SHOW_USERGROUP_USERS: 'SHOW_USERGROUP_USERS',
  SHOW_USERGROUP_USERS_ERROR: 'SHOW_USERGROUP_USERS_ERROR',
  UPDATE_USERGROUP_MEMBERS: 'UPDATE_USERGROUP_MEMBERS',
  UPDATE_USERGROUP_MEMBERS_ERROR: 'UPDATE_USERGROUP_MEMBERS_ERROR',
  UPDATE_USERGROUP_MEMBERS_SUCCESS: 'UPDATE_USERGROUP_MEMBERS_SUCCESS',
  UPDATE_USERGROUP_USERS_TO_ADD: 'UPDATE_USERGROUP_USERS_TO_ADD',
};

export const userUsergroupsActions = {
  ADD_USERS_GROUPS: 'ADD_USERS_GROUPS',
  ADD_USERS_GROUPS_ERROR: 'ADD_USERS_GROUPS_ERROR',
  ADD_USERS_GROUPS_SUCCESS: 'ADD_USERS_GROUPS_SUCCESS',
  ADD_USERS_GROUPS_LOCAL: 'ADD_USERS_GROUPS_LOCAL',
  DISMISS_USERS_GROUPS_ERROR: 'DISMISS_USERS_GROUPS_ERROR',
  FETCH_FILTERED_GROUPS: 'FETCH_FILTERED_GROUPS',
  FETCH_USERS_GROUPS: 'FETCH_USERS_GROUPS',
  REMOVE_USERS_GROUP: 'REMOVE_USERS_GROUP',
  REMOVE_USERS_GROUP_ERROR: 'REMOVE_USERS_GROUP_ERROR',
  REMOVE_USERS_GROUP_SUCCESS: 'REMOVE_USERS_GROUP_SUCCESS',
  REMOVE_USERS_GROUP_LOCAL: 'REMOVE_USERS_GROUP_LOCAL',
  SHOW_FILTERED_GROUPS: 'SHOW_FILTERED_GROUPS',
  SHOW_FILTERED_GROUPS_ERROR: 'SHOW_FILTERED_GROUPS_ERROR',
  SHOW_USERS_GROUPS: 'SHOW_USERS_GROUPS',
  SHOW_USERS_GROUPS_ERROR: 'SHOW_USERS_GROUPS_ERROR',
  TOGGLE_ASSIGN_USERS_TO_USER_GROUP_SELECTED: 'TOGGLE_ASSIGN_USERS_TO_USER_GROUP_SELECTED',
  UPDATE_USERS_GROUPS_TO_ADD: 'UPDATE_USERS_GROUPS_TO_ADD',
  UPDATE_USERS_USERGROUP_PROPERTIES: 'UPDATE_USERS_USERGROUP_PROPERTIES',
};

export const userGroupLists = ['all'];

export const userGroupCategories = [...userGroupLists, 'open', 'deletion', 'assign'];

export const userGroupStates = {
  ...defaultStates,
  ...saveStates,
};

export const userGroupTabs = {
  USERS: { name: 'users', icon: 'user' },
};

export const PANELS = Object.freeze({
  USERS: 0,
});
